import React, { Component } from "react";
import Container from "../../../modules/commons/Container";
import CustomerProfileCDBHeader from "./customerProfileCDBHeader";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { TABLE_COLUMN_CONFIG } from "./config";
import CustomerProfileCDBModifying from "./customerProfileCDBModifying";
import { fetchDataAsync } from "../../../Services/Utils";
import Api from "../../../Services/Api";
import { HttpStatus } from "../../common/Constants";
import * as R from "ramda";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import ErrorAction from "../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import FlexView from "react-flexview";
import { defaultTableChange } from "../../../modules/custom/customTable";

class CustomerProfileCDB extends Component {
  constructor(props) {
    super(props);
    this.initialHeaderData = {
      checkboxnama: false,
      checkboxnik: false,
      checkboxnomorTeleponHP: false,
      nama: "",
      nik: "",
      nomorTeleponHP: "",
    };
    this.state = {
      modalModifyingVisible: false,
      errorVisible: false,
      errorMessage: null,
      tableColumns: this.getTableColumns({ page: 1, limit: 5 }),
      dataHeader: this.initialHeaderData,
      selectedData: null,
      dataTable: [],
      pagination: {
        count: 0,
        limit: 5,
        page: 1,
        orderBy: "id",
        sort: "ASC",
      },
    };
  }

  getTableColumns() {
    let columns = TABLE_COLUMN_CONFIG.map((col) => {
      if (col.name === "") {
        return {
          ...col,
          options: {
            ...col.options,
            customBodyRender: (_, tableMeta) => {
              const page = this.state.pagination.page; 
              const limit = this.state.pagination.limit;

              
              const rowNumber = (page - 1) * limit + tableMeta.rowIndex + 1;
              return <>{rowNumber}</>;
            },
          },
        };
      }
      return col;
    });

    columns.push({
      name: "action",
      label: "Aksi",
      options: {
        customBodyRender: (_, tableMeta) => (
          <SimpleButton
            type="button"
            category="action_button"
            text="Proses Ekspedisi"
            icon={
              <i
                style={{ fontSize: 20, color: "red" }}
                className="fa fa-lg fa-eye"
              />
            }
            onClick={() =>
              this.handleModalModifyingVisibility(tableMeta.rowIndex)
            }
          />
        ),
        sort: false,
      },
    });

    return columns;
  }

  handleModalModifyingVisibility = (index) => {
    this.setState((prevState) => ({
      ...prevState,
      modalModifyingVisible: !prevState.modalModifyingVisible,
      selectedData: prevState.dataTable[index],
    }));
  };

  handleErrorVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      errorMessage: text,
      errorVisible: !prevState.errorVisible,
    }));
  };

  handleValueChange = (name, value) => {
    this.setState((prevState) => ({
      ...prevState,
      dataHeader: {
        ...prevState.dataHeader,
        [name]: value,
      },
    }));
  };

  handleValueChangeCheckBox = (name, value) => {
    this.setState((prevState) => ({
      ...prevState,
      dataHeader: {
        ...prevState.dataHeader,
        [name]: value,
      },
    }));
  };

  handleSubmitSearch = async () => {
    this.setState((prevValue) => ({ ...prevValue, loading: true }));
    const req = {};
    const { dataHeader, pagination } = this.state;

    Object.keys(dataHeader).forEach((key) => {
      if (key.startsWith("checkbox") && dataHeader[key]) {
        const field = key.replace("checkbox", "");
        req[field] = dataHeader[field];
      }
    });

    req.page = pagination.page;
    req.limit = pagination.limit;

    if (!R.isEmpty(req)) {
      const res = await this.fetchData(req);
      this.setState({ loading: false });

      if (res.ok && res.data.status === HttpStatus.FAILED) {
        return;
      }

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        const resultData = res.data.data ?? [];
        const totalCount = res.data.totalData;

        this.setState((prevState) => ({
          ...prevState,
          dataTable: resultData,
          pagination: {
            ...prevState.pagination,
            count: totalCount,
          },
        }));

        if (resultData.length === 0) {
          this.handleErrorVisibility("Data tidak ditemukan");
        }

        if (resultData.length === 1) {
          const inputNama = dataHeader.nama?.trim().toLowerCase();
          const resultNama = resultData[0].nama?.trim().toLowerCase();

          if (inputNama && inputNama === resultNama) {
            this.handleModalModifyingVisibility(0);
            return;
          }
        }
      }
    }
  };

  handleClearSearch = () => {
    this.setState((prevState) => ({
      ...prevState,
      dataHeader: this.initialHeaderData,
    }));
  };

  fetchData = async (filter = {}) => {
    return fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getAllCDB,
      setError: this.props.setError,
      menuName: "CDB - Customer Profile",
      args: filter,
    });
  };

  handleChangePage = async (tableState) => {
    this.setState(
      (prevValue) => ({
        ...prevValue,
        pagination: {
          ...prevValue.pagination,
          page: tableState.page + 1,
        },
      }),
      () => this.handleSubmitSearch(),
    );
  };

  handleChangeRowsPerPage = async (tableState) => {
    this.setState(
      (prevValue) => ({
        ...prevValue,
        pagination: {
          ...prevValue.pagination,
          page: 1,
          limit: tableState.rowsPerPage,
        },
      }),
      () => this.handleSubmitSearch(),
    );
  };

  render() {
    return (
      <Container>
        <CustomerProfileCDBHeader
          dataHeader={this.state.dataHeader}
          onValueChange={this.handleValueChange}
          onValueChangeCheckBox={this.handleValueChangeCheckBox}
          onSumbitSearch={this.handleSubmitSearch}
          onClearSearch={this.handleClearSearch}
        />

        {this.state.dataTable.length >= 1 && (
          <SimpleDataTable
            key={`${this.state.pagination.count}-${this.state.pagination.page}`}
            data={this.state.dataTable}
            columns={this.state.tableColumns}
            toCount={this.state.pagination.count}
            rowsPerPage={this.state.pagination.limit}
            page={this.state.pagination.page - 1}
            options={defaultTableChange(
              this.handleChangePage,
              this.handleChangeRowsPerPage,
            )}
          />
        )}

        {this.state.modalModifyingVisible && (
          <CustomerProfileCDBModifying
            {...this.props}
            selectedData={this.state.selectedData}
            visible={this.state.modalModifyingVisible}
            onClickClose={this.handleModalModifyingVisibility}
          />
        )}

        {this.state.errorVisible && (
          <SimpleAlert
            title="Information"
            visible={this.state.errorVisible}
            content={
              <div>
                <p>{this.state.errorMessage}</p>
                <FlexView hAlignContent="center">
                  <SimpleButton
                    className="margin-top-15px"
                    text="OK"
                    onClick={this.handleErrorVisibility}
                  />
                </FlexView>
              </div>
            }
            onClickClose={this.handleErrorVisibility}
          />
        )}

        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(CustomerProfileCDB);
